import {Component, OnInit} from '@angular/core';
import {AuthService} from "./auth.service";
import {Router} from "@angular/router";
import {QuestionService} from "./question.service";
import {QuizService} from "./quiz.service";
import {PlayerService} from "./player.service";
import {TopListService} from "./top-list.service";

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  providers: [
    QuestionService,
    QuizService,
    PlayerService,
    TopListService
  ]
})
export class AppComponent implements OnInit {
  title = 'METSÄVISAN HALLINTA v1.1.0';

  public authorized: boolean = false;

  constructor(private authService: AuthService,
              private router: Router,
              private topListService: TopListService) {
    authService.currentAdmin$.subscribe(newAdmin => {
      if (newAdmin) {
        this.authorized = true;
      }
      else {
        this.authorized = false;
      }
    });
  }

  ngOnInit(): void {
    this.authService.update();
  }

  public logout() {
    this.authService.logout().subscribe(
      res => {
        console.log("logout res");
        this.authorized = false;
        this.router.navigate(['/login']);
      },
      err => {
        console.log("logout err");
        this.router.navigate(['/login']);
      }
    );
  }


  public get adminName(): string {
    let admin = this.authService.currentAdmin$.value;
    if (!admin) {
      return "null??"
    }
    return admin.name;
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts